export const AlternativeSymbol = (): JSX.Element => (
  <span>
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_9794_625)'>
        <path
          d='M13.5418 7.94122C13.5418 9.81312 13.0775 11.6528 12.1997 13.2742L2.03857 32.0004H8.75277L13.1521 24.2014C14.5552 21.7139 15.2941 18.8684 15.2941 15.9693V-0.000976562H13.5385V7.94122H13.5418Z'
          fill='#FAFAFA'
        />
        <path
          d='M18.4622 7.94126V-0.000930786H16.7065V15.9658C16.7065 18.8649 17.4488 21.7104 18.8486 24.1979L23.2479 31.9969H29.9621L19.801 13.2707C18.9198 11.6493 18.4588 9.80959 18.4588 7.93768L18.4622 7.94126Z'
          fill='#FAFAFA'
        />
      </g>
      <defs>
        <clipPath id='clip0_9794_625'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </svg>
  </span>
)
